/* Lacie 2026 theme scripts */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const money = (cents) => {
    const fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: fmt }).format(cents / 100);
  };

  function setPrice(el, now, was) {
    el.classList.toggle('price--sale', Boolean(was));
    const nowEl = document.createElement('span');
    nowEl.className = 'price__now';
    nowEl.textContent = now;
    const parts = [nowEl];
    if (was) {
      const s = document.createElement('s');
      s.className = 'price__was';
      const hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.textContent = 'Regular price';
      s.append(hidden, was);
      parts.push(s);
    }
    el.replaceChildren(...parts);
  }

  /* ---------- Cart drawer ---------- */
  const drawer = () => document.getElementById('CartDrawer');

  function openDrawer() {
    const d = drawer();
    if (d && !d.open) d.showModal();
  }
  function closeDrawer() {
    const d = drawer();
    if (d && d.open) d.close();
  }

  function renderDrawer(html) {
    const d = drawer();
    if (!d || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer-inner]');
    const current = d.querySelector('[data-cart-drawer-inner]');
    if (fresh && current) {
      current.replaceWith(fresh);
      const count = fresh.dataset.count;
      document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = count; });
      const link = document.querySelector('.cart-link');
      if (link) {
        link.classList.add('is-bumped');
        setTimeout(() => link.classList.remove('is-bumped'), 900);
      }
    }
  }

  async function addToCart(form) {
    const button = form.querySelector('[type="submit"]') ||
      (form.id && document.querySelector(`[type="submit"][form="${form.id}"]`));
    const errorEl = form.querySelector('[data-form-error]');
    const buttons = form.id ? document.querySelectorAll(`[form="${form.id}"], #${CSS.escape(form.id)} [type="submit"]`) : [button];
    buttons.forEach((b) => b && b.classList.add('is-loading'));
    if (errorEl) errorEl.hidden = true;

    const body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add this item.');
      renderDrawer(data.sections && data.sections['cart-drawer']);
      openDrawer();
    } catch (err) {
      if (errorEl) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      } else {
        window.alert(err.message);
      }
    } finally {
      buttons.forEach((b) => b && b.classList.remove('is-loading'));
    }
  }

  async function changeLine(line, quantity) {
    const res = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (data.sections) renderDrawer(data.sections['cart-drawer']);
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-cart-form]');
    if (!form || !drawer()) return;
    e.preventDefault();
    addToCart(form);
  });

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && drawer()) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      closeDrawer();
      return;
    }
    const change = e.target.closest('[data-qty-change]');
    if (change) {
      const line = change.closest('[data-line]');
      if (line) changeLine(Number(line.dataset.line), Number(change.dataset.qtyChange));
      return;
    }
    // click on the backdrop closes the drawer
    const d = drawer();
    if (d && e.target === d) closeDrawer();
  });

  /* ---------- Quick add on cards ---------- */
  class QuickAdd extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (e) => {
        const radio = e.target.closest('input[type="radio"]');
        if (!radio) return;
        this.querySelector('input[name="id"]').value = radio.value;
        const card = this.closest('.card');
        const price = card && card.querySelector('[data-price]');
        if (price && radio.dataset.price) setPrice(price, radio.dataset.price, radio.dataset.was);
      });
    }
  }
  customElements.define('quick-add', QuickAdd);

  /* ---------- Product page ---------- */
  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.form = this.querySelector('form.product-form');
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-qty-preset]')) {
          const input = this.querySelector('.qty__input');
          if (input) input.value = e.target.value;
          return;
        }
        if (e.target.matches('.option[data-option-index] input[type="radio"]')) this.onOptionChange();
      });
      this.addEventListener('input', (e) => {
        if (!e.target.matches('.qty__input')) return;
        this.querySelectorAll('[data-qty-preset]').forEach((r) => { r.checked = r.value === e.target.value; });
      });
      this.querySelectorAll('[data-step]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const input = this.querySelector('.qty__input');
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.step));
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });
      this.setupStickyBuy();
    }

    selectedOptions() {
      return [...this.querySelectorAll('.option[data-option-index]')].map((fs) => {
        const checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    onOptionChange() {
      const opts = this.selectedOptions();
      this.querySelectorAll('.option[data-option-index]').forEach((fs, i) => {
        const label = fs.querySelector('[data-option-value]');
        if (label) label.textContent = opts[i];
      });
      const variant = this.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      const buttons = this.querySelectorAll('[data-add-button]');
      if (!variant) {
        buttons.forEach((b) => { b.disabled = true; b.textContent = 'Unavailable'; });
        return;
      }
      this.querySelector('[data-variant-id]').value = variant.id;
      buttons.forEach((b) => {
        b.disabled = !variant.available;
        b.textContent = variant.available ? b.dataset.labelAdd : 'Sold out';
      });
      const price = this.querySelector('.product__info [data-price]');
      if (price) {
        const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        setPrice(price, money(variant.price), sale ? money(variant.compare_at_price) : null);
      }
      const sticky = this.querySelector('[data-sticky-price]');
      if (sticky) sticky.textContent = money(variant.price);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (variant.featured_media) {
        const slide = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
        const track = this.querySelector('[data-gallery-track]');
        if (slide && track) {
          if (getComputedStyle(track).display === 'flex') {
            track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          } else {
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            slide.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
          }
        }
      }
    }

    setupStickyBuy() {
      const bar = this.querySelector('[data-sticky-buy]');
      const main = this.form && this.form.querySelector('[data-add-button]');
      if (!bar || !main || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
        bar.querySelector('button').tabIndex = show ? 0 : -1;
      });
      io.observe(main);
    }
  }
  customElements.define('product-page', ProductPage);

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-gallery-track]');
      const index = this.querySelector('[data-gallery-index]');
      if (!track || !index) return;
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / track.clientWidth) + 1;
        index.textContent = i;
      }, { passive: true });
    }
  }
  customElements.define('product-gallery', ProductGallery);

  /* ---------- Drop countdown ---------- */
  class DropCountdown extends HTMLElement {
    connectedCallback() {
      this.target = Date.parse(this.dataset.target);
      if (Number.isNaN(this.target)) return;
      this.units = {
        d: this.querySelector('[data-unit="d"]'),
        h: this.querySelector('[data-unit="h"]'),
        m: this.querySelector('[data-unit="m"]'),
        s: this.querySelector('[data-unit="s"]')
      };
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      let diff = Math.max(0, this.target - Date.now());
      if (diff === 0) {
        clearInterval(this.timer);
        this.classList.add('is-done');
        const when = this.querySelector('.countdown__when');
        if (when) when.textContent = this.dataset.done || '';
        return;
      }
      const pad = (n) => String(n).padStart(2, '0');
      const d = Math.floor(diff / 864e5); diff -= d * 864e5;
      const h = Math.floor(diff / 36e5); diff -= h * 36e5;
      const m = Math.floor(diff / 6e4); diff -= m * 6e4;
      const s = Math.floor(diff / 1e3);
      this.units.d.textContent = d;
      this.units.h.textContent = pad(h);
      this.units.m.textContent = pad(m);
      this.units.s.textContent = pad(s);
    }
  }
  customElements.define('drop-countdown', DropCountdown);

  /* close mobile menu on outside click */
  document.addEventListener('click', (e) => {
    const nav = document.querySelector('.mobile-nav[open]');
    if (nav && !nav.contains(e.target)) nav.removeAttribute('open');
  });
})();
